module.exports = __webpack_public_path__ + "img/img_vision_us@3x.9c82c696.png";